import { ReactElement, useState } from "react";

import PageAlertContext, { Alert } from "../contexts/PageAlertContext";

const PageAlertProvider = ({
  children,
}: {
  children: ReactElement;
}): ReactElement => {
  const [alert, setAlert] = useState<Alert>({ message: "" });
  const providerValues = {
    alert,
    setAlert,
    removeAlert: () => setAlert({ message: "" }),
  };

  return (
    <PageAlertContext.Provider value={providerValues}>
      {children}
    </PageAlertContext.Provider>
  );
};

export default PageAlertProvider;
